"use client";
import AboutContainer from "@/components/About/AboutContainer";

export default function AboutPage() {
  return <AboutContainer />;
}
